import {event} from "d3-selection";

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-drag/src/noevent.js
// module id = 486
// module chunks = 0